import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SortByFieldPipe } from 'src/app/core/pipes/sort-by-field.pipe';
import { ShareDirectivesModule } from '../../../core/directives/directives.module';
import { SharePipesModule } from '../../../core/pipes/pipes.module';
import { TranslationModule } from '../../../i18n/translation.module';
import { MaterialModule } from '../../modules/material/material.module';
import { FieldSearcherModule } from '../field-searcher/field-searcher.module';
import { FieldSorterModule } from '../field-sorter/field-sorter.module';
import { PaginatorModule } from '../paginator/paginator.module';
import { ResizeColumnDirective } from './directive/resize-column.directive';
import { SetPositionByIndexDirective } from './directive/set-position-by-index.directive';
import { SortColumnsDirective } from './directive/sort-column.directive';
import { StickyPositionDirective } from './directive/sticky-position.directive';
import { DynamicTableComponent } from './dynamic-table.component';
import { TableDataItemComponent } from './table-data-item/table-data-item.component';

@NgModule({
  declarations: [DynamicTableComponent, TableDataItemComponent],
  imports: [
    CommonModule,
    MaterialModule,
    TranslationModule,
    ShareDirectivesModule,
    SharePipesModule,
    FieldSorterModule,
    FieldSearcherModule,
    PaginatorModule,
    StickyPositionDirective,
    SetPositionByIndexDirective,
    ResizeColumnDirective,
    SortColumnsDirective,
    SortByFieldPipe,
  ],
  exports: [DynamicTableComponent, TableDataItemComponent],
})
export class DynamicTableModule {}
